
<template>
    <div v-show="showLoader === true"
  class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-main-color border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
  role="status">
  <span
    class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"
    >Loading...</span
  >
</div>
</template>
<script setup>
defineProps({
    showLoader: {
            type: Boolean,
            default: true
        },
})
</script>
